"use client";

import { c as _c } from "react/compiler-runtime";
import { useIsMobile } from "@/hooks/use-mobile";
import { type BreadcrumbItem } from "@/utils/breadcrumb-utils";
import { ChevronRight } from "lucide-react";
import React, { useEffect, useState } from "react";
import { ClickableBreadcrumb, EllipsisBreadcrumb, NavigationBreadcrumb } from "./breadcrumb-components";
interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
  onBreadcrumbClick?: (item: BreadcrumbItem, index: number) => void | Promise<void>;
  disabled?: boolean;
}
export const Breadcrumbs: React.FC<BreadcrumbsProps> = t0 => {
  const $ = _c(31);
  const {
    items,
    className: t1,
    onBreadcrumbClick,
    disabled: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const disabled = t2 === undefined ? false : t2;
  const isMobile = useIsMobile();
  const [isClient, setIsClient] = useState(false);
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setIsClient(true);
    };
    t4 = [];
    $[0] = t3;
    $[1] = t4;
  } else {
    t3 = $[0];
    t4 = $[1];
  }
  useEffect(t3, t4);
  let t5;
  if ($[2] !== isClient || $[3] !== isMobile || $[4] !== items) {
    t5 = isClient && isMobile && items.length > 3 ? [items[0], {
      label: "...",
      variant: "default" as const
    }, ...items.slice(-2)] : items;
    $[2] = isClient;
    $[3] = isMobile;
    $[4] = items;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const displayItems = t5;
  let t6;
  if ($[6] !== onBreadcrumbClick) {
    t6 = async (item, index) => {
      if (onBreadcrumbClick) {
        await onBreadcrumbClick(item, index);
      }
    };
    $[6] = onBreadcrumbClick;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const handleBreadcrumbClick = t6;
  let t7;
  if ($[8] !== disabled || $[9] !== displayItems.length || $[10] !== handleBreadcrumbClick || $[11] !== isMobile) {
    t7 = (item_0, index_0) => {
      const isLastItem = index_0 === displayItems.length - 1;
      const BreadCrumbComp = item_0.href && !isLastItem ? NavigationBreadcrumb : ClickableBreadcrumb;
      if (item_0.label === "...") {
        return <EllipsisBreadcrumb isMobile={isMobile} />;
      }
      return <BreadCrumbComp item={item_0} isMobile={isMobile} onClick={() => handleBreadcrumbClick(item_0, index_0)} disabled={disabled || isLastItem} />;
    };
    $[8] = disabled;
    $[9] = displayItems.length;
    $[10] = handleBreadcrumbClick;
    $[11] = isMobile;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const renderBreadcrumbItem = t7;
  const t8 = `${className}`;
  const t9 = `flex items-center ${isClient && isMobile ? "gap-0.5" : "gap-1"} text-sm`;
  const t10 = `flex items-center ${isClient && isMobile ? "gap-0.5" : "gap-1"}`;
  let t11;
  if ($[13] !== displayItems || $[14] !== isClient || $[15] !== isMobile || $[16] !== renderBreadcrumbItem) {
    let t12;
    if ($[18] !== isClient || $[19] !== isMobile || $[20] !== renderBreadcrumbItem) {
      t12 = (item_1, index_1) => <li key={index_1} className={`flex items-center ${isClient && isMobile ? "gap-0.5" : "gap-1"}`}>{index_1 > 0 && <ChevronRight className="w-3 h-3 text-muted-foreground flex-shrink-0" />}{renderBreadcrumbItem(item_1, index_1)}</li>;
      $[18] = isClient;
      $[19] = isMobile;
      $[20] = renderBreadcrumbItem;
      $[21] = t12;
    } else {
      t12 = $[21];
    }
    t11 = displayItems.map(t12);
    $[13] = displayItems;
    $[14] = isClient;
    $[15] = isMobile;
    $[16] = renderBreadcrumbItem;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11) {
    t12 = <ol className={t10}>{t11}</ol>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t9) {
    t13 = <nav className={t9} aria-label="Breadcrumb">{t12}</nav>;
    $[25] = t12;
    $[26] = t9;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13 || $[29] !== t8) {
    t14 = <div className={t8}>{t13}</div>;
    $[28] = t13;
    $[29] = t8;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  return t14;
};
export default Breadcrumbs;